module.exports = __webpack_public_path__ + "img/appltCourse-img5.8074852e.png";